import { extendTheme } from '@chakra-ui/react';
import { breakpoints } from './breakpoints';
import colorScheme, { ColorScheme, greenColorScheme } from './colorScheme';

import buttonTheme from './components/button';
import containerTheme from './components/container';
import fontSizes from './fontSizes';
import inputTheme from './components/input';
import formLabelTheme from './components/formLabel';
import textTheme from './components/text';
import headingTheme from './components/heading';
import dividerTheme from './components/divider';
import { tabsTheme } from './components/tabs';

export interface AppTheme {
  colors: ColorScheme;
  components: Record<string, any>;
  breakpoints: Record<string, number>;
  [key: string]: any;
}

const appTheme: AppTheme = extendTheme({
  fonts: {
    heading: 'GTWalsheimPro',
    body: 'GTWalsheimPro',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 600,
    extrabold: 600,
    700: 600,
    800: 600,
  },
  colors: {
    ...colorScheme,
    green: greenColorScheme,
  },
  components: {
    Button: buttonTheme,
    Container: containerTheme,
    Input: inputTheme,
    NumberInput: inputTheme,
    Select: inputTheme,
    FormLabel: formLabelTheme,
    Text: textTheme,
    Heading: headingTheme,
    Divider: dividerTheme,
    Tabs: tabsTheme,
  },
  breakpoints,
  fontSizes,
}) as AppTheme;

export default appTheme;
